/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_StartedInputs */



/**
* | output |
* | --- |
* | "Snap To shot changes started... please wait." |
*
* @param {Snap_To_Shot_Changes_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_started = /** @type {((inputs?: Snap_To_Shot_Changes_StartedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_StartedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement sur les changements de plan en cours... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Änderungen an Snap To Shot wurden gestartet... bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche allo scatto avviate... attendere prego.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начались изменения в функции Snap To shot... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se iniciaron los cambios en la toma Snap To... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照更改已开始……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スナップ ショットの変更が開始されました... お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैप टू शॉट में बदलाव शुरू हो गए हैं... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As alterações do Snap To Shot foram iniciadas... aguarde.")
	return /** @type {LocalizedString} */ ("Snap To shot changes started... please wait.")
});